import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20abstract%20organic%20flowing%20shapes%20in%20warm%20cream%20and%20soft%20sage%20green%20tones%2C%20minimalist%20natural%20texture%20with%20gentle%20light%20diffusion%2C%20serene%20wellness%20and%20beauty%20aesthetic%2C%20elegant%20gradient%20background%20with%20subtle%20golden%20accents%2C%20ethereal%20and%20calming%20atmosphere&width=1920&height=1080&seq=hero-main-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 max-w-3xl mx-auto text-center">
        <span className="inline-block text-xs md:text-sm font-label font-medium tracking-[0.2em] uppercase text-primary-300 bg-white/10 backdrop-blur-sm px-5 py-2 rounded-full mb-6">
          科学抗衰 · 永葆青春
        </span>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-white leading-tight">
          科学抗衰让你
          <br className="hidden md:block" />
          越活越年轻
        </h1>
        <p className="mt-5 md:mt-6 text-sm md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
          从护肤养生到生活习惯，汇集科学抗衰全方案，帮助你从内到外逆龄而生，
          掌握真正让肌肤与活力长久留存的核心方法，告别衰老困扰，重拾年轻状态。
        </p>
        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/kang-shuai-hu-fu"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            开始探索 <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/15 hover:bg-white/25 text-white font-medium text-sm rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}